module.exports = __webpack_public_path__ + "static/img/user.1214def.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/user.jpg
// module id = BQ5I
// module chunks = 2